import{useContext as o,useMemo as r}from"react";import n from"./AnalyticsContext";import{useAuth as e}from"@praxis/component-auth";import t from"./Analytics";import i from"./__internals__/useValueMemo";/** Hook providing access to tracking functions for functional components.
 *
 * @param eventManagerConfiguration [Optional]
 * @example
 * const MyComponent = () => {
 *   const {
 *     trackClick,
 *     trackView,
 *     trackCustomEvent,
 *     trackEvent,
 *     trackTaskInit,
 *     trackTaskDone,
 *   } = useAnalytics({ apiKey: '', appName: 'my-app' })
 *
 *   ...
 * }
 */const s=s=>{const a=o(n);const l=e();let u;if(!l||l.noProvider===true){// Don't fetch the loginId - we're not in an <AuthProvider>
}else{var m,d;u=(d=l.session)===null||d===void 0?void 0:(m=d.userInfo)===null||m===void 0?void 0:m.lanId}const f=i(s);const c=r(()=>{if(a){a.loginId=u;return a}if(f===undefined){throw new Error(`'useAnalytics' must be called from inside an '<AnalyticsProvider>', or must be provided with an 'eventManagerConfiguration' argument.`)}return new t(f,u)},[f,u,a]);return c};export default s;